import i18next from 'i18next';

i18next.addResources('es', 'ScheduleReportPDF', {
  title: 'Título',
  time: 'Hora',
  type: 'Tipo de tarea',
  scheduleReport: 'INFORME DE AGENDA: {{range}}'
});
